import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Principles',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Principles',
        href: '/adm/opr/principless',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_principle',
    sortDesc: true,
    fields: [
      {
        key: 'code',
        sortable: true,
      },
      {
        key: 'company',
        label: 'Company',
        sortable: true,
      },
      {
        key: 'email',
        label: 'Email',
      },
      {
        key: 'phone',
        label: 'Phone',
      },
      {
        key: 'storage_free',
        label: 'Free Day',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_choose_principle: [
      {
        key: 'code',
        sortable: true,
      },
      {
        key: 'company',
        label: 'Company',
        sortable: true,
      },
      {
        key: 'email',
        label: 'Email',
      },
      {
        key: 'phone',
        label: 'Phone',
      },
    ],
    detail: false,
    form: {
      code: '',
      company: '',
      city: '',
      province: '',
      country: '',
      postal_code: '',
      email: '',
      phone: '',
      fax: '',
      storage_free: '',
      storage_add: '',
      storage_min: '',
      storage_max: '',
      logo: '',
      address: [
        {
          address: '',
          cities: 'SURABAYA',
          is_primary: 2,
        },
      ],
      daily_report: {
        email_to: '',
        time: [
          {
            start_time: '',
            end_time: '',
          },
        ],
      },
    },
    form_ftp: {},
    form_edi: {},
    form_report_edi: [],
    form_report_excel: [],
    container_type: [],
    container_cleaning: [],
    import_form: [],
    items_edi_type: [],
    items_report_edi: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  form_ftp(state) {
    return state.data.form_ftp;
  },
  form_edi(state) {
    return state.data.form_edi;
  },
  form_report_edi(state) {
    return state.data.form_report_edi;
  },
  form_report_excel(state) {
    return state.data.form_report_excel;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changePrinciple(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchPrinciple(context, params = null) {
    let result = await ApiGetRequest(`opr/principles`, params);
    return !result.error ? result.data.object : [];
  },

  // Principle Account FTP
  async getDetailAccountFTP({ commit, state }) {
    commit('changePrinciple', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(
      `opr/principles/${
        data && data.detail?.id_principle ? data.detail.id_principle : 0
      }/account-ftp`
    );

    let form_ftp =
      !result.error && result?.data?.object
        ? result.data.object
        : data.form_ftp;

    commit('changePrinciple', {
      loading: false,
      form_ftp,
    });

    return result.error ? false : true;
  },

  async createAccountFTP({ state, commit, dispatch }) {
    commit('changePrinciple', {
      loading: true,
    });

    let result = await ApiPostRequest(
      `opr/principles/account-ftp`,
      state.data.form_ftp
    );

    commit('changePrinciple', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateAccountFTP({ commit, state, dispatch }, payload = null) {
    commit('changePrinciple', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `opr/principles/account-ftp/${payload.id}`,
      data.form_ftp
    );

    commit('changePrinciple', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  // Principle EDI Type
  async getListEDIType({ commit, state }) {
    commit('changePrinciple', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(
      `opr/principles/${
        data && data.detail?.id_principle ? data.detail.id_principle : 0
      }/edi-type`
    );

    commit('changePrinciple', {
      items_edi_type: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },

  async createEDIType({ state, commit, dispatch }) {
    commit('changePrinciple', {
      loading: true,
    });

    let result = await ApiPostRequest(
      `opr/principles/edi-type`,
      state.data.form_edi
    );

    commit('changePrinciple', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateEDIType({ commit, state, dispatch }, payload = null) {
    commit('changePrinciple', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `opr/principles/edi-type/${payload.id}`,
      data.form_edi
    );

    commit('changePrinciple', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteEDIType({ commit, dispatch }, payload = null) {
    commit('changePrinciple', {
      loading: true,
    });

    let result = await ApiDeleteRequest(
      `opr/principles/edi-type/${payload.id}`
    );

    commit('changePrinciple', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  // Principle Report EDI
  async getListReportEDI({ commit, state }) {
    commit('changePrinciple', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(
      `opr/principles/${
        data && data.detail?.id_principle ? data.detail.id_principle : 0
      }/edi-daily-report`
    );

    commit('changePrinciple', {
      form_report_edi: {
        ...data.form_report_edi,
        items:
          !result.error && result.data.object && result.data.object.length
            ? result.data.object
            : [
                {
                  type_send: 'ftp',
                  cont_type: '',
                  doc_type: '',
                  id_principle_edi: '',
                  email_edi: '',
                  report_type: 'repeat',
                  start_time: '',
                  end_time: '',
                  repeat_time: 10,
                },
              ],
      },
      loading: false,
    });

    return !result.error ? true : false;
  },

  async createReportEDI({ state, commit, dispatch }) {
    commit('changePrinciple', {
      loading: true,
    });

    let result = await ApiPostRequest(
      `opr/principles/edi-daily-report`,
      state.data.form_report_edi
    );

    commit('changePrinciple', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  // Principle Report Excel
  async getListReportExcel({ commit, state }) {
    commit('changePrinciple', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(
      `opr/principles/${
        data && data.detail?.id_principle ? data.detail.id_principle : 0
      }/excel-daily-report`
    );

    commit('changePrinciple', {
      form_report_excel:
        !result.error && result.data.object
          ? result.data.object
          : data.form_report_excel,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async createReportExcel({ state, commit, dispatch }) {
    commit('changePrinciple', {
      loading: true,
    });

    let result = await ApiPostRequest(
      `opr/principles/excel-daily-report`,
      state.data.form_report_excel
    );

    commit('changePrinciple', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateReportExcel({ state, commit, dispatch }, payload = null) {
    commit('changePrinciple', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `opr/principles/excel-daily-report/${payload.id}`,
      state.data.form_report_excel
    );

    commit('changePrinciple', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async getListPrinciple({ commit, state }) {
    commit('changePrinciple', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`opr/principles`, params);
    commit('changePrinciple', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailPrinciple({ commit }, payload = null) {
    commit('changePrinciple', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/principles/${payload.id}`);
    let detail = result.error ? false : result.data.object;

    if (!detail.principle_address || detail.principle_address.length === 0) {
      detail.principle_address = [
        {
          name: '',
          cities: 'SURABAYA',
          is_primary: 2,
        },
      ];
    }

    commit('changePrinciple', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async uploadLogo({ commit, state }, payload) {
    commit('changePrinciple', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/photo`, payload);
    commit('changePrinciple', {
      loading: false,
    });

    if (!result.error) {
      commit('changePrinciple', {
        form: {
          ...data.form,
          logo: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }) {
    commit('changePrinciple', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`opr/principles/import`, {
      items: data.import_form || [],
    });

    commit('changePrinciple', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createPrinciple({ state, commit, dispatch }) {
    commit('changePrinciple', {
      loading: true,
    });

    let result = await ApiPostRequest(`opr/principles`, state.data.form);
    commit('changePrinciple', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updatePrinciple({ commit, state, dispatch }, payload = null) {
    commit('changePrinciple', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(`opr/principles/${payload.id}`, data.form);

    commit('changePrinciple', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deletePrinciple({ commit, dispatch }, payload = null) {
    commit('changePrinciple', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/principles/${payload.id}`);
    commit('changePrinciple', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
